import { AddIcon, Box, HStack, Pressable, Text, VStack } from "native-base";
import React, { FC } from "react";
import AVAdd from "../components/common/AVAdd";
import AVCancel from "../components/common/AVCancel";
import "../Screens/Home/style.css";
import * as AV from "../AVCore/AVCore";
import { RootStateOrAny, useSelector } from "react-redux";
import { Loc } from '../App/Loc';

function FilePicker ( props : any )
{
    const currentUser = useSelector( ( state : RootStateOrAny ) => state?.user?.user[ 0 ] );
    const [ images, setImages ] = React.useState<any>( [] );
    const [ media, setMedia ] = React.useState<any>( [] );
    const [ showAddMedia, setShowAddMedia ] = React.useState( false );
    const [ picker, setPicker ] = React.useState( false );
    const [ isImageProcessing, setIsImageProcessing ] = React.useState( false );
    const [ noticeMessage, setNoticeMessage ] = React.useState( "" );
    const imageInputRef = React.useRef<any>( null );

    const handleImages = async ( e : any ) =>
    {
        let files : any = Array.from( e?.target?.files );
        setShowAddMedia( false );
        setPicker( false );
        files.forEach( ( img : any ) =>
        {
            if (
                img.type !== "image/jpeg" &&
                img.type !== "image/png" &&
                /*img.type !== "image/webp" &&*/
                img.type !== "image/gif"
            )
            {
                files = files.filter( ( item : any ) => item.name !== img.name );
                return;
            }
            else
            {
                const reader = new FileReader();
                reader.readAsDataURL( img );
                reader.onload = ( readerEvent : any ) =>
                {
                    setImages( images => [ ...images, readerEvent.target.result ] );
                };
            }
        } );
        setIsImageProcessing( true );
        setNoticeMessage( "Please wait while we process your images..." );
        const data = await AV.Media.saveFiles( AV.Media.getFormData( files ), currentUser?.region );
        if (data[0]?.status == "Invalid Size") {
	      setNoticeMessage(Loc.currentLang.alertMessages.largeVideo);
          setIsImageProcessing( false );

	      return;
	    }

        setMedia( prev =>
        {
            return { ...prev, ...data };
        } );
        setNoticeMessage( "" );
        setIsImageProcessing( false );
    };
    return (
        <>
            <div className="overflow_a scrollbar">
                <input
                    type="file"
                    accept="image/jpeg,image/png,image/gif"
                    multiple
                    hidden
                    ref={ imageInputRef }
                    onChange={ handleImages }
                />
                <HStack my={ 3 } mx={ 5 } space={ 4 } alignItems={ "center" } zIndex={ 0 }>
                    { images && images.length ? (
                        <RenderImages images={ images } imageInputRef={ imageInputRef } setImages={ setImages } />
                    ) : (
                        <Box
                            //my={ 1 }
                            // mx={ 3 }
                            borderWidth={ 1 }
                            borderRadius={ 5 }
                            overflow={ "hidden" }
                            borderColor={ "avcolors.black" }
                            borderStyle={ "none" }
                            maxH={ "300px" }
                            height="100%"
                            width="100%"
                            overflowY={ "auto" }
                        //  zIndex={ 0 }
                        >
                            <Pressable onPress={ () => imageInputRef?.current.click() }>
                                <VStack alignItems={ "center" } justifyContent={ "center" } minH={ "150px" } space={ 2 }>
                                    <Box backgroundColor={ "AVColor.grey" } p={ 2 } borderRadius="full">
                                        <AddIcon color={ "AVColor.secondary" } />
                                    </Box>
                                    <Text fontSize={ 14 } color={ "AVColor.grey" }>
                                        (images / videos)
                                    </Text>
                                </VStack>
                            </Pressable>
                        </Box>
                    ) }
                </HStack>
            </div>
        </>
    );
}
const RenderImages = ( { images, imageInputRef, setImages } ) =>
{
    return (
        <div className="add_pics_inside1 p0">
            <div className="preview_actions">
                <AVAdd addEvent={ () => imageInputRef.current.click() } />
            </div>
            <div
                className="small_white_circle"
                onClick={ () =>
                {
                    setImages( [] );
                } }
            >
                <AVCancel callback={ () => setImages( [] ) } color={ "#000000" } size={ undefined } />
            </div>
            <div
                className={
                    images.length === 1
                        ? "preview1"
                        : images.length === 2
                            ? "preview2"
                            : images.length === 3
                                ? "preview3"
                                : images.length === 4
                                    ? "preview4 "
                                    : images.length === 5
                                        ? "preview5"
                                        : images.length % 2 === 0
                                            ? "preview6"
                                            : "preview6 singular_grid"
                }
            >
                { images.map( ( img, i ) => (
                    <img src={ img } key={ i } alt="" className="Image" />
                ) ) }
            </div>
        </div>
    );
};


export default FilePicker;
